import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react'
import classes from './LanguageDropdown.module.scss'
import { ReactComponent as Arrow } from 'assets/bds_caret-down_24.svg'
import { useTranslation } from 'react-i18next'

interface LanguageDropdownProps {
  language: any
  isOpen?: boolean
}

export const LanguageDropdown: React.FunctionComponent<LanguageDropdownProps> =
  ({ language, isOpen = false }) => {
    const inputRef = useRef<HTMLUListElement>(null)
    const { i18n } = useTranslation()
    const [open, setOpen] = useState<boolean>(isOpen)
    const [selection, setSelection] = useState<any>(language)
    const lang = useMemo(
      () => [
        {
          label: 'Deutsch',
          value: 'de',
        },
        {
          label: 'English',
          value: 'en',
        },
      ],
      []
    )

    const langChange = useCallback(
      (lang: string) => {
        if (lang === 'en' || lang === 'en-US') {
          return i18n.changeLanguage('en')
        }
        if (lang === 'de' || lang === 'de-DE') {
          return i18n.changeLanguage('de')
        }
      },
      [i18n]
    )
    const handleGlobalClick = useCallback(
      (event: MouseEvent) => {
        if (
          inputRef.current?.parentElement &&
          !inputRef.current.parentElement.contains(event.target as HTMLElement)
        ) {
          setOpen(false)
        }
      },
      [inputRef]
    )
    useEffect(() => {
      if (i18n.language === 'de' || i18n.language === 'de-DE') {
        langChange('de')
        setSelection(lang[0].value)
      }
      if (i18n.language === 'en' || i18n.language === 'en-US') {
        langChange('en')
        setSelection(lang[1].value)
      }
    }, [i18n.language, lang, langChange])

    useEffect(() => {
      if (!open) {
        return
      }
      document.addEventListener('click', handleGlobalClick)
      return () => {
        document.addEventListener('click', handleGlobalClick)
      }
    }, [open, handleGlobalClick])
    const renderLanguage = () => {
      if (selection !== undefined && selection.startsWith('en')) {
        return 'EN'
      }
      return 'DE'
    }
    return (
      <div className={classes.wrapper}>
        <div
          tabIndex={0}
          className={classes.header}
          role="button"
          onKeyPress={() => setOpen(!open)}
          onClick={() => setOpen(!open)}
        >
          <div className={classes.headerAction}>
            <p style={{ textTransform: 'uppercase' }}>
              {renderLanguage()} <Arrow />
            </p>
          </div>
        </div>
        {open && (
          <ul ref={inputRef} className={classes.list}>
            {lang.map((item, id) => (
              <li className={classes.listItem} key={id}>
                <button
                  type="button"
                  onClick={() => {
                    setSelection(item.value)
                    setOpen(false)
                    langChange(item.value)
                  }}
                >
                  <span>
                    {lang[id].label}{' '}
                    <span style={{ textTransform: 'uppercase' }}>
                      ({item.value})
                    </span>
                  </span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    )
  }
